<template>
  <div class="leaderboard-page">
    <div class="head">
      <div class="label">{{ $t(`${i18nPrefix}.menu`) }}</div>
    </div>
    <div class="content">
      <div class="leaderboard-box">
        <div class="head-btn">
          <el-button
            class="btn"
            v-for="(item, index) in status"
            :key="index"
            :class="item.isActive && 'is-active'"
            @click="changeStatus(item.value)"
          >
            {{ $t(`personal.referrals.leaderboard.status.${item.value}`) }}
          </el-button>
        </div>
        <TableList
          v-rect-loading="loading"
          class="leaderboard-list"
          row-key="id"
          noHead
          noAction
          :rowClassName="getRowClassName"
          :listData="leaderboardList"
          :tableColumns="tableColumns"
          :showCreateBtn="false"
        >
          <template #index="{ row }">
            <span>{{ formatIndex(row.index) }}</span>
          </template>
          <template #photo="{row}">
            <div class="photo">
              <img
                class="img"
                :title="row.name"
                :src="$DjangoMediaUrl(row.photo_url)"
                @error="getDefaultProfilePhoto($event)"
              >
            </div>
          </template>
        </TableList>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { padStart } from 'lodash'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import { formatBigNumber } from '@/components/filters'

export default {
  components: {
    TableList
  },
  data () {
    return {
      i18nPrefix: 'personal.referrals.leaderboard',
      select: 'applied',
      loading: false,
      status: [
        { value: 'views', isActive: false },
        { value: 'submits', isActive: false },
        { value: 'applied', isActive: true },
        { value: 'interviewed', isActive: false },
        { value: 'onboard', isActive: false },
        { value: 'probation', isActive: false },
        { value: 'all', isActive: false }
      ],
      leaderboardList: [],
      selfInfo: []
    }
  },
  computed: {
    tableColumns () {
      return [
        {
          dataKey: 'index',
          slotName: 'index',
          width: '20px'
        },
        {
          width: '30px',
          dataKey: 'photo',
          slotName: 'photo'
        },
        {
          width: '500px',
          dataKey: 'name'
        },
        {
          width: '100px',
          align: 'right',
          dataKey: 'count',
          formatter: (data) => {
            return formatBigNumber(data, 1)
          }
        }
      ]
    }
  },
  created () {
    this.initData()
  },
  mounted () {

  },
  methods: {
    ...mapActions('personal', ['getMyLeaderBoardData']),
    initData () {
      this.getLeaderBoardData()
    },
    async getLeaderBoardData () {
      this.loading = true
      try {
        const resp = await this.getMyLeaderBoardData({ status: this.select })
        if (resp) {
          resp.self.self = true
          this.leaderboardList = [resp.self, ...resp.list]
        }
      } finally {
        this.loading = false
      }
    },
    formatCount (data) {
      data = data + ''
      const reg = /(?=(?!\b)(?:\d{3})+(?!\d))/g
      if (data) {
        return data.trim().replace(reg, ',')
      }
      return data
    },
    getDefaultProfilePhoto (e) {
      e.target.src = this.$DjangoStaticUrl('images_en/default.jpg')
    },
    changeStatus (status) {
      this.select = status
      this.status.forEach(item => {
        if (item.value !== status) {
          item.isActive = false
        } else {
          item.isActive = true
        }
      })
      this.getLeaderBoardData()
    },
    formatIndex (index) {
      return padStart(index, '2', '0')
    },
    getRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'self'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.leaderboard-page {
  min-height: calc(100vh - var(--header-height, 124px) - 28px);
  min-height: calc(100dvh - var(--header-height, 124px) - 28px);
  background-color: #fff;

  .head {
    display: flex;
    position: sticky;
    top: -14px;
    height: 52px;
    padding: 16px 0 16px 40px;
    z-index: 3;
    background-color: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);

    .label {
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;
      color: #606266;
    }
  }

  .content {
    padding: 0 40px 0;

    .leaderboard-box {
      padding-top: 5px;
      border-radius: 5px;

      .leaderboard-list {

        .photo {
          padding-top: 5px;

          .img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }

        ::v-deep {
          .el-table__header-wrapper {
            display: none;
          }

          .self {
            .el-table_1_column_1 {
              border-left: 4px solid #0096cc;

              .cell {
                position: relative;
                left: -4px;
              }
            }
          }

          .el-table {
            .el-table__cell {
              padding: 8px 0;
            }
          }
        }
      }

      .head-btn {
        display: flex;
        padding: 10px;
        margin-bottom: 10px;
        font-size: 12px;
        border-bottom: 1px solid #ddd;
        justify-content: space-around;

        .btn {
          height: 36px;
          padding: 5px 10px;

          &:hover, &.is-active {
            background: #0096cc;
            border-color: #0096cc;
            color: #ffffff;
            transition-duration: .3s;
          }
        }
      }
    }
  }
}
</style>
